import { DataSource, HorizontalSpacer, Label, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceExpand extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelInvoiceDetail: Label;
    layoutMiscInvoiceDetail: Layout;
    sourceMiscBill: DataSource;
    sourceMiscBillDetail: DataSource;
    tabDetail: Tab;
    tabsetMiscInvoiceExpand: Tabset;
    textboxAllocationCode: Textbox;
}
